import * as React from 'react';
import { Input } from '@progress/kendo-react-inputs';

export type StreetAddressViewModel = {
    Line1: string;
    Line2: string;
    City: string;
    State: string;
    Zip: string;
}

type Props = {
    address: StreetAddressViewModel | null;
    onChange: (newAddress: StreetAddressViewModel) => void;
    title: string;
    index?: number;
    required?: boolean;
    validation?: boolean;
}

export default class StreetAddress extends React.PureComponent<Props> {

    public render() {
        return <React.Fragment>
        <button type="button" className="btn btn-primary" data-toggle="modal" data-target={"#" + this.props.title.replace(" ", "").replace("'", "") + this.props.index}>
        {this.props.address && (this.props.address.Line1 || this.props.address.Line2 || this.props.address.City || this.props.address.State || this.props.address.Zip) ? this.props.address.Line1 : 'Set ' + this.props.title + (this.props.required ? '*' : '')}
            <br/>
            {this.props.address && this.props.address.Line2}
            {this.props.address && this.props.address.Line2 && <br/>}
            {this.props.address && this.props.address.City}
            {' '}
            {this.props.address && this.props.address.State}
            {' '}
            {this.props.address && this.props.address.Zip}
        </button>
        {this.props.validation && this.props.required && this.props.address && (!this.props.address.Line1 || !this.props.address.City || !this.props.address.State) && <p className="error-msg" style={{ marginBottom: 0 }}>{this.props.title} is Required</p>}
        {this.props.validation && !this.props.required && this.props.address && (this.props.address.Line1 || this.props.address.Line2 || this.props.address.City || this.props.address.State || this.props.address.Zip) && (!this.props.address.Line1 || !this.props.address.City || !this.props.address.State) && <p style={{ color: '#dc3545', marginBottom: 0 }}>{this.props.title} Missing Data</p>}
        <div className="modal fade" id={this.props.title.replace(" ", "").replace("'", "") + this.props.index} tabIndex={-1} role="dialog" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">{this.props.title}</h5>
                        <button  type="button" className="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div className="modal-body">
                        <label className="k-form-field">
                            <span>Address Line 1{this.props.required && <span style={{ color: '#dc3545' }}>*</span>}</span>
                            <Input
                                type="text"
                                placeholder="Address Line 1"
                                autoComplete="street-address address-line1"
                                maxLength={40}
                                value={this.props.address ? this.props.address.Line1: ""}
                                onChange={(e) => this.updateStreetAddress({ Line1: e.target.value })}
                            />
                        </label>
                        <label className="k-form-field">
                            <span>Address Line 2</span>
                            <Input
                                type="text"
                                placeholder="Address Line 2"
                                autoComplete="street-address address-line2"
                                maxLength={40}
                                value={this.props.address ? this.props.address.Line2: ""}
                                onChange={(e) => this.updateStreetAddress({ Line2: e.target.value })}
                            />
                        </label>
                        <label className="k-form-field">
                            <span>City{this.props.required && <span style={{ color: '#dc3545' }}>*</span>}</span>
                            <Input
                                type="text"
                                placeholder="City"
                                autoComplete="address-level2"
                                maxLength={40}
                                value={this.props.address ? this.props.address.City: ""}
                                onChange={(e) => this.updateStreetAddress({ City: e.target.value })}
                            />
                        </label>
                        <label className="k-form-field">
                            <span>Province{this.props.required && <span style={{ color: '#dc3545' }}>*</span>}</span>
                            <Input
                                type="text"
                                placeholder="e.g. ON"
                                autoComplete="address-level1"
                                maxLength={2}
                                value={this.props.address ? this.props.address.State: ""}
                                onChange={(e) => this.updateStreetAddress({ State: e.target.value })}
                            />
                        </label>
                        <label className="k-form-field">
                            <span>Postal Code</span>
                            <Input
                                type="text"
                                placeholder="Postal Code"
                                autoComplete="postal-code"
                                maxLength={10}
                                value={this.props.address ? this.props.address.Zip: ""}
                                onChange={(e) => this.updateStreetAddress({ Zip: e.target.value })}
                            />
                        </label>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-primary" data-dismiss="modal">Done</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </React.Fragment>;
    }

    private updateStreetAddress(value: Partial<StreetAddressViewModel>) {
        const newAddress = Object.assign({Line1: "", Line2: "", City: "", State: "", Zip: ""}, this.props.address, value);
        this.props.onChange(newAddress);
    }
}
